import styled from '@emotion/styled';
import Divider from '@mui/material/Divider';
import Rating from '@mui/material/Rating';
import React from 'react'
import Childrens from './Childrens';
import Chip from '@mui/material/Chip';
import Reviews from './Reviews';
import mainContext from '../../../contexts/mainContext';
import { getSeekerProfileController } from '../../../Controllers/userManagment/customer';
import CloseIcon from '@mui/icons-material/Close';
import OfficialAccount from '../../Common/OfficialAccount';
import { __constants, __snackBarSeverity, __snackBarText } from '../../../constants';

const lookingForLabels = {
    BabySitter: "Babysitter",
    HouseKeeper: "Housekeeper"
};

const SeekerProfile = ({ open, setOpen, userId, onOfficialChange }) => {
    const { setCanvasTitle, setSnackBar, setPageload, loginUserDetails } = React.useContext(mainContext);
    const [seeker, setSeeker] = React.useState({});
    const [rawImage, setRawImage] = React.useState()

    const getSeekerProfile = async () => {
        setPageload(true)
        const res = await getSeekerProfileController(userId);
        setPageload(false)
        if (res && res.status === 500) {
            return setSnackBar({
                status: true,
                text: __snackBarText.internalServerError,
                severity: __snackBarSeverity.error
            })
        }
        if (res.data.status !== 200) {
            return setSnackBar({
                status: true,
                text: res.data.errors[0].message || __snackBarText.unKnownError,
                severity: __snackBarSeverity.error
            })
        }
        if (res.data.data.seeker.length === 0) {
            return setSnackBar({
                status: true,
                text: __snackBarText.noDataFound,
                severity: __snackBarSeverity.error
            })
        }
        let seekerInfo = { ...res.data.data.seeker[0] }
        seekerInfo.promoCode = res.data.data.promoCode
        setSeeker(seekerInfo);
        setRawImage(`${__constants.images}${res.data.data.seeker[0]?.profilePicture}`)
    }


    React.useEffect(() => {
        if (open) {
            getSeekerProfile();
        }
        setCanvasTitle("Customer profile");
    }, [])

    return (
        <>
            <Container>
                <Header>
                    <h4>{seeker?.firstName} {seeker?.lastName} profile</h4>
                    <CloseIcon className='pointer' onClick={() => { setOpen(false) }} />
                </Header>
                {
                    Object.keys(seeker).length > 0 ?
                        <>
                            <Body className='scroll-bar-hidden'>
                                <ProfilePic>
                                    <div className="img-container">
                                    <img
                                     onError={(e) => {
                                         setRawImage(`${__constants.images}default_upscaled.png`) }} 
                                         src={rawImage} />
                                    {/* <div className='blur-effect'></div>
                                    <div className='footer'>
                                        <Name>{seeker.firstName} {seeker.lastName}</Name>
                                        <Ratings className='review-sec'>
                                            {seeker.review.count} reviews
                                            <Rating name="read-only" value={seeker.review.avg} readOnly sx={{ fontSize: "95%" }} />
                                        </Ratings>
                                    </div> */}
                                    </div>
                                </ProfilePic>
                                <UserDeatils>
                                    <UserAbout>
                                        <strong className="title">
                                            Onboarding Progress
                                        </strong>
                                        <div style={{ marginTop: '0.5rem', fontSize: '90%' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                                <span style={{ marginRight: '8px' }}>✅</span>
                                                <span>Registered</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                                <span style={{ marginRight: '8px' }}>{seeker?.isEmailVerify ? '✅' : '❌'}</span>
                                                <span style={{ opacity: seeker?.isEmailVerify ? 1 : 0.6 }}>Email Verified</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                                <span style={{ marginRight: '8px' }}>{seeker?.isMobileNoVerify ? '✅' : '❌'}</span>
                                                <span style={{ opacity: seeker?.isMobileNoVerify ? 1 : 0.6 }}>OTP Verified</span>
                                            </div>
                                        </div>
                                    </UserAbout>
                                    {loginUserDetails?.role !== "Concierge" && (
                                        <>
                                            <Divider className='divider-gap' />
                                            <UserAbout>
                                                <strong className="title">
                                                    Official Account
                                                </strong>
                                                <div style={{ marginTop: '0.5rem', fontSize: '90%' }}>
                                                    <OfficialAccount
                                                        userId={userId}
                                                        isOfficial={seeker?.isOfficial}
                                                        contactEmail={seeker?.officialContactEmail}
                                                        website={seeker?.officialWebsite}
                                                        onSaved={({ isOfficial, contactEmail, website }) => {
                                                            setSeeker((prev) => ({ ...prev, isOfficial, officialContactEmail: contactEmail || null, officialWebsite: website || null }))
                                                            onOfficialChange?.(isOfficial)
                                                        }}
                                                    />
                                                </div>
                                            </UserAbout>
                                        </>
                                    )}
                                    <Divider className='divider-gap' />
                                    <Languages>
                                        <strong className="title">
                                            Looking for
                                        </strong>
                                        <div>
                                            {
                                                seeker?.lookingFor?.length > 0 ? seeker.lookingFor.map((item) => <Chip key={item} label={lookingForLabels[item] || item} size="small" className="mui-clip" />) :
                                                    <div>Not specified yet.</div>
                                            }
                                        </div>
                                    </Languages>
                                    <Divider className='divider-gap' />
                                    <UserAbout>
                                        <strong className="title">
                                            Referral
                                        </strong>
                                        <p>{seeker?.promoCode?.referralCode || "Not available"}</p>
                                    </UserAbout>
                                    <Divider className='divider-gap' />
                                    <UserAbout>
                                        <strong className="title">
                                            About
                                        </strong>
                                        <p className="heading">Hi I'm {seeker.firstName || ' .....'}</p>
                                        <p>{seeker.aboutMe}</p>
                                    </UserAbout>
                                    <Divider className='divider-gap' />
                                    <Childrens childrens={seeker.childrens} />
                                    <Divider className='divider-gap' />

                                    {/* <Needs> */}
                                    {/* <strong className="title">
                                            What I need
                                        </strong> */}
                                    {
                                        // seeker.needs.length > 0 ?
                                        //     <div>
                                        //         {
                                        //             seeker.needs.map((item) => {
                                        //                 return (
                                        //                     <span>
                                        //                         {/* <img src={`${BASE_URL}${item[0]?.file || ""}`} alt="" /> */}
                                        //                         {item.length > 0 && item[0].name}
                                        //                     </span>
                                        //                 )
                                        //             })
                                        //         }

                                        //     </div>
                                        //     : <div>No need add yet.</div>
                                    }
                                    {/* </Needs> */}

                                    {/* <Divider className='divider-gap' /> */}
                                    <Languages>
                                        <strong className="title">
                                            Language
                                        </strong>
                                        <div>
                                            {
                                                seeker?.languages[0]?.length > 0 ? seeker?.languages[0]?.map((lng) => <Chip label={lng} size="small" className="mui-clip" />) :
                                                    <div>No languages add yet.</div>
                                            }
                                        </div>
                                    </Languages>
                                    <Divider className='divider-gap' />
                                    <Reviews reviewDetails={seeker.reviewDetails} review={seeker.review} userId={userId} />
                                </UserDeatils>
                            </Body>
                        </>
                        :
                        <>
                            <br />
                            Customer profile not completed
                        </>
                }
            </Container>
        </>
    )
}

const Container = styled("div")`
    height: 100vh;
    width: 30vw;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    overflow: hidden;
    min-width:300px;
    .title{
        color: var(--nona-theme-color);
        font-size: 90%;
    }
    .heading{
        color: var(--nona-theme-color);
        font-size: 90%;
        margin-bottom:10px;
    }
    .divider-gap{
        margin: 0.5rem 0;
    }
    .button{
      border-radius: 10px;
      width: 100%;
      text-transform: unset;
      display: flex;
      font-family: 'semi-bold'
    }
    .chip{
        width: fit-content;
        background-color: var(--nona-light-blue);
    }
    .image_handler{
        height: 200px;
        width: 100%;
        object-fit: cover;
    }
`;

const Header = styled("div")`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4{
        font-weight: 900;
        font-size: 120%;
    }
    padding-bottom: 0.7rem;
    border-bottom: 1px solid var(--card-border);
`;

const Body = styled("div")`
    margin-top: 1rem;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`;

const ProfilePic = styled("div")`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    
    .img-container {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        overflow: hidden;
        border: 3px solid #e2a988;
    }
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
`;

const Name = styled("div")`
    font-weight: 600;
    color: #fff;
`;

const Ratings = styled("div")`
    display: flex;
    align-items: center;
    column-gap: 0.5rem;
    font-size: 80%;
    color: #fff;
`;

const UserDeatils = styled("div")`
    width: 95%;
    margin: auto;
`;

const UserAbout = styled("div")`
    p{
        margin-top: 0.2rem;
        font-size: 80%;
    }
`;

const Needs = styled("div")`
    &>div{
        margin-top: 0.5rem;
        display: grid;
        &>span{
            display: flex;
            align-items: center;
            column-gap: 1rem;
            img{
                height: 30px;
                width: 30px;
                clip-path: circle();
            }
        }
    }
`;

const Languages = styled("div")`
    &>div{
        margin-top: 0.3rem;
        display: flex;
        flex-wrap: wrap;
        column-gap: 0.5rem;
    }
`;

const Footer = styled("div")`
    margin: auto;
    margin-top: 5%;
    padding-bottom: 5%;
    width: 95%;
    display: flex;
    justify-content: center;
    column-gap: 1rem;
`;

export default SeekerProfile